import { render, staticRenderFns } from "./CreateUserComponent.vue?vue&type=template&id=01de1958&scoped=true"
import script from "./CreateUserComponent.vue?vue&type=script&lang=js"
export * from "./CreateUserComponent.vue?vue&type=script&lang=js"
import style0 from "./CreateUserComponent.vue?vue&type=style&index=0&id=01de1958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de1958",
  null
  
)

export default component.exports